import api, { publicApi } from './api';

const sortByName = (categories = []) =>
  [...categories].sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', 'es', { sensitivity: 'base' })
  );

const categoryService = {
  /**
   * Obtener todas las categorías (público, sin autenticación)
   */
  async getAllPublic(params = {}) {
    try {
      const response = await publicApi.get('/categories', { params });
      return {
        success: true,
        data: sortByName(response.data.data)
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener categorías'
      };
    }
  },

  /**
   * Obtener todas las categorías
   */
  async getAll(params = {}) {
    try {
      const response = await api.get('/categories', { params });
      return {
        success: true,
        data: sortByName(response.data.data)
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener categorías'
      };
    }
  },

  /**
   * Obtener categoría por ID
   */
  async getById(id) {
    try {
      const response = await api.get(`/categories/${id}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener categoría'
      };
    }
  },

  /**
   * Crear categoría
   */
  async create(categoryData) {
    try {
      const response = await api.post('/categories', categoryData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear categoría'
      };
    }
  },

  /**
   * Actualizar categoría
   */
  async update(id, categoryData) {
    try {
      const response = await api.put(`/categories/${id}`, categoryData);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar categoría'
      };
    }
  },

  /**
   * Eliminar categoría
   */
  async delete(id) {
    try {
      const response = await api.delete(`/categories/${id}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar categoría'
      };
    }
  }
};

export default categoryService;


